import { render, staticRenderFns } from "./petty-cash.vue?vue&type=template&id=b44722d6&scoped=true"
import script from "./petty-cash.vue?vue&type=script&lang=js"
export * from "./petty-cash.vue?vue&type=script&lang=js"
import style0 from "./petty-cash.vue?vue&type=style&index=0&id=b44722d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44722d6",
  null
  
)

export default component.exports